<markant-callout colorScheme="warning" theme="light" class="callout">
  <div slot="content">
    <div class="callout-content flex-centered">
      <markant-icon icon="m_warning"></markant-icon>
      <p>
        <span>{{ translationKey | transloco }}</span>
      </p>
    </div>
  </div>
</markant-callout>
